// extracted by mini-css-extract-plugin
module.exports = {"root":"_39lcp","icon":"_20mbH"};